var _path, _path2, _line, _path3, _path4, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaninsoftLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 538,
    height: 338,
    viewBox: "0 0 538 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.08 217.4C77.68 214.28 74.64 211.88 70.96 210.2C67.28 208.52 63.48 207.68 59.56 207.68C54.76 207.68 50.4 208.6 46.48 210.44C42.64 212.2 39.32 214.64 36.52 217.76C33.8 220.88 31.68 224.56 30.16 228.8C28.64 232.96 27.88 237.44 27.88 242.24C27.88 246.72 28.6 250.96 30.04 254.96C31.48 258.96 33.56 262.48 36.28 265.52C39 268.56 42.32 270.96 46.24 272.72C50.16 274.48 54.6 275.36 59.56 275.36C64.44 275.36 68.72 274.36 72.4 272.36C76.08 270.36 79.2 267.56 81.76 263.96L91.48 271.28C90.84 272.16 89.72 273.44 88.12 275.12C86.52 276.72 84.4 278.36 81.76 280.04C79.12 281.64 75.92 283.04 72.16 284.24C68.48 285.52 64.2 286.16 59.32 286.16C52.6 286.16 46.52 284.88 41.08 282.32C35.72 279.76 31.12 276.4 27.28 272.24C23.52 268.08 20.64 263.4 18.64 258.2C16.64 252.92 15.64 247.6 15.64 242.24C15.64 235.68 16.72 229.64 18.88 224.12C21.04 218.52 24.04 213.72 27.88 209.72C31.8 205.64 36.48 202.48 41.92 200.24C47.36 198 53.36 196.88 59.92 196.88C65.52 196.88 71 197.96 76.36 200.12C81.8 202.28 86.24 205.6 89.68 210.08L80.08 217.4ZM102.892 234.08C105.932 231.28 109.452 229.2 113.452 227.84C117.452 226.4 121.452 225.68 125.452 225.68C129.612 225.68 133.172 226.2 136.132 227.24C139.172 228.28 141.652 229.68 143.572 231.44C145.492 233.2 146.892 235.24 147.772 237.56C148.732 239.8 149.212 242.16 149.212 244.64V273.68C149.212 275.68 149.252 277.52 149.332 279.2C149.412 280.88 149.532 282.48 149.692 284H140.092C139.852 281.12 139.732 278.24 139.732 275.36H139.492C137.092 279.04 134.252 281.64 130.972 283.16C127.692 284.68 123.892 285.44 119.572 285.44C116.932 285.44 114.412 285.08 112.012 284.36C109.612 283.64 107.492 282.56 105.652 281.12C103.892 279.68 102.492 277.92 101.452 275.84C100.412 273.68 99.8922 271.2 99.8922 268.4C99.8922 264.72 100.692 261.64 102.292 259.16C103.972 256.68 106.212 254.68 109.012 253.16C111.892 251.56 115.212 250.44 118.972 249.8C122.812 249.08 126.892 248.72 131.212 248.72H139.132V246.32C139.132 244.88 138.852 243.44 138.292 242C137.732 240.56 136.892 239.28 135.772 238.16C134.652 236.96 133.252 236.04 131.572 235.4C129.892 234.68 127.892 234.32 125.572 234.32C123.492 234.32 121.652 234.52 120.052 234.92C118.532 235.32 117.132 235.84 115.852 236.48C114.572 237.04 113.412 237.72 112.372 238.52C111.332 239.32 110.332 240.08 109.372 240.8L102.892 234.08ZM133.372 256.64C130.812 256.64 128.172 256.8 125.452 257.12C122.812 257.36 120.372 257.88 118.132 258.68C115.972 259.48 114.172 260.6 112.732 262.04C111.372 263.48 110.692 265.32 110.692 267.56C110.692 270.84 111.772 273.2 113.932 274.64C116.172 276.08 119.172 276.8 122.932 276.8C125.892 276.8 128.412 276.32 130.492 275.36C132.572 274.32 134.252 273 135.532 271.4C136.812 269.8 137.732 268.04 138.292 266.12C138.852 264.12 139.132 262.16 139.132 260.24V256.64H133.372ZM164.879 227.12H175.679V235.88H175.919C177.279 232.84 179.639 230.4 182.999 228.56C186.359 226.64 190.239 225.68 194.639 225.68C197.359 225.68 199.959 226.12 202.439 227C204.999 227.8 207.199 229.08 209.039 230.84C210.959 232.6 212.479 234.88 213.599 237.68C214.719 240.4 215.279 243.64 215.279 247.4V284H204.479V250.4C204.479 247.76 204.119 245.52 203.399 243.68C202.679 241.76 201.719 240.24 200.519 239.12C199.319 237.92 197.919 237.08 196.319 236.6C194.799 236.04 193.199 235.76 191.519 235.76C189.279 235.76 187.199 236.12 185.279 236.84C183.359 237.56 181.679 238.72 180.239 240.32C178.799 241.84 177.679 243.8 176.879 246.2C176.079 248.6 175.679 251.44 175.679 254.72V284H164.879V227.12ZM232.398 227.12H243.198V284H232.398V227.12ZM229.878 206.72C229.878 204.56 230.638 202.72 232.158 201.2C233.758 199.6 235.638 198.8 237.798 198.8C239.958 198.8 241.798 199.6 243.318 201.2C244.918 202.72 245.718 204.56 245.718 206.72C245.718 208.88 244.918 210.76 243.318 212.36C241.798 213.88 239.958 214.64 237.798 214.64C235.638 214.64 233.758 213.88 232.158 212.36C230.638 210.76 229.878 208.88 229.878 206.72ZM260.387 227.12H271.187V235.88H271.427C272.787 232.84 275.147 230.4 278.507 228.56C281.867 226.64 285.747 225.68 290.147 225.68C292.867 225.68 295.467 226.12 297.947 227C300.507 227.8 302.707 229.08 304.547 230.84C306.467 232.6 307.987 234.88 309.107 237.68C310.227 240.4 310.787 243.64 310.787 247.4V284H299.987V250.4C299.987 247.76 299.627 245.52 298.907 243.68C298.187 241.76 297.227 240.24 296.027 239.12C294.827 237.92 293.427 237.08 291.827 236.6C290.307 236.04 288.707 235.76 287.027 235.76C284.787 235.76 282.707 236.12 280.787 236.84C278.867 237.56 277.187 238.72 275.747 240.32C274.307 241.84 273.187 243.8 272.387 246.2C271.587 248.6 271.187 251.44 271.187 254.72V284H260.387V227.12Z",
    fill: "#0071BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.306 241.4C356.026 239.8 354.426 238.48 352.506 237.44C350.666 236.32 348.386 235.76 345.666 235.76C343.106 235.76 340.866 236.32 338.946 237.44C337.106 238.48 336.186 240.04 336.186 242.12C336.186 243.8 336.706 245.16 337.746 246.2C338.866 247.24 340.146 248.08 341.586 248.72C343.106 249.36 344.706 249.84 346.386 250.16C348.066 250.48 349.506 250.76 350.706 251C353.026 251.56 355.186 252.24 357.186 253.04C359.266 253.84 361.026 254.88 362.466 256.16C363.986 257.44 365.146 259 365.946 260.84C366.826 262.68 367.266 264.92 367.266 267.56C367.266 270.76 366.586 273.52 365.226 275.84C363.866 278.08 362.106 279.92 359.946 281.36C357.786 282.8 355.306 283.84 352.506 284.48C349.786 285.12 347.026 285.44 344.226 285.44C339.506 285.44 335.346 284.72 331.746 283.28C328.226 281.84 325.066 279.2 322.266 275.36L330.426 268.64C332.186 270.4 334.146 271.96 336.306 273.32C338.466 274.68 341.106 275.36 344.226 275.36C345.586 275.36 346.946 275.24 348.306 275C349.746 274.68 350.986 274.24 352.026 273.68C353.146 273.04 354.026 272.28 354.666 271.4C355.386 270.44 355.746 269.36 355.746 268.16C355.746 266.56 355.226 265.24 354.186 264.2C353.226 263.16 352.026 262.36 350.586 261.8C349.226 261.16 347.746 260.68 346.146 260.36C344.626 259.96 343.266 259.64 342.066 259.4C339.746 258.84 337.546 258.2 335.466 257.48C333.386 256.76 331.546 255.8 329.946 254.6C328.346 253.4 327.066 251.88 326.106 250.04C325.146 248.2 324.666 245.92 324.666 243.2C324.666 240.24 325.266 237.68 326.466 235.52C327.746 233.28 329.386 231.44 331.386 230C333.466 228.56 335.786 227.48 338.346 226.76C340.986 226.04 343.626 225.68 346.266 225.68C350.106 225.68 353.786 226.4 357.306 227.84C360.826 229.28 363.626 231.68 365.706 235.04L357.306 241.4ZM389.147 255.56C389.147 258.44 389.587 261.12 390.467 263.6C391.347 266 392.587 268.08 394.187 269.84C395.787 271.52 397.747 272.88 400.067 273.92C402.387 274.88 404.987 275.36 407.867 275.36C410.747 275.36 413.347 274.88 415.667 273.92C417.987 272.88 419.947 271.52 421.547 269.84C423.147 268.08 424.387 266 425.267 263.6C426.147 261.12 426.587 258.44 426.587 255.56C426.587 252.68 426.147 250.04 425.267 247.64C424.387 245.16 423.147 243.08 421.547 241.4C419.947 239.64 417.987 238.28 415.667 237.32C413.347 236.28 410.747 235.76 407.867 235.76C404.987 235.76 402.387 236.28 400.067 237.32C397.747 238.28 395.787 239.64 394.187 241.4C392.587 243.08 391.347 245.16 390.467 247.64C389.587 250.04 389.147 252.68 389.147 255.56ZM377.627 255.56C377.627 251.4 378.387 247.52 379.907 243.92C381.507 240.32 383.667 237.16 386.387 234.44C389.107 231.72 392.307 229.6 395.987 228.08C399.667 226.48 403.627 225.68 407.867 225.68C412.107 225.68 416.067 226.48 419.747 228.08C423.427 229.6 426.627 231.72 429.347 234.44C432.067 237.16 434.187 240.32 435.707 243.92C437.307 247.52 438.107 251.4 438.107 255.56C438.107 259.72 437.307 263.64 435.707 267.32C434.187 270.92 432.067 274.08 429.347 276.8C426.627 279.44 423.427 281.56 419.747 283.16C416.067 284.68 412.107 285.44 407.867 285.44C403.627 285.44 399.667 284.68 395.987 283.16C392.307 281.56 389.107 279.44 386.387 276.8C383.667 274.08 381.507 270.92 379.907 267.32C378.387 263.64 377.627 259.72 377.627 255.56ZM455.837 236.48H443.597V227.12H455.837V214.4C455.837 206.8 457.277 201.16 460.157 197.48C463.117 193.72 468.157 191.84 475.277 191.84C476.477 191.84 477.717 191.88 478.997 191.96C480.357 192.04 481.797 192.28 483.317 192.68L482.117 202.28C481.077 201.88 480.077 201.6 479.117 201.44C478.157 201.28 477.117 201.2 475.997 201.2C473.997 201.2 472.397 201.52 471.197 202.16C469.997 202.72 469.037 203.56 468.317 204.68C467.677 205.8 467.237 207.16 466.997 208.76C466.837 210.28 466.757 212.04 466.757 214.04V227.12H479.597V236.48H466.637V284H455.837V236.48ZM522.078 236.48H506.598V262.28C506.598 263.88 506.638 265.48 506.718 267.08C506.798 268.6 507.078 270 507.558 271.28C508.118 272.48 508.918 273.48 509.958 274.28C511.078 275 512.678 275.36 514.758 275.36C516.038 275.36 517.358 275.24 518.717 275C520.078 274.76 521.318 274.32 522.438 273.68V283.52C521.158 284.24 519.478 284.72 517.398 284.96C515.398 285.28 513.838 285.44 512.718 285.44C508.558 285.44 505.318 284.88 502.998 283.76C500.758 282.56 499.078 281.04 497.958 279.2C496.918 277.36 496.278 275.32 496.038 273.08C495.878 270.76 495.798 268.44 495.798 266.12V236.48H483.317V227.12H495.798V211.16H506.598V227.12H522.078V236.48Z",
    fill: "#898989"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 274.5,
    y1: 10,
    x2: 274.5,
    y2: 80,
    stroke: "#CBCBCB",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260 10.0039V38.0039L248 55.0039",
    stroke: "#CBCBCB",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M290 10.0039V38.0039L302 55.0039",
    stroke: "#CBCBCB",
    strokeWidth: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 250.676,
    y1: 74.2668,
    x2: 262.676,
    y2: 85.2668,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 285.375,
    y1: 88.223,
    x2: 300.375,
    y2: 76.223,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 327.293,
    y1: 86.711,
    x2: 316.293,
    y2: 75.711,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 348.148,
    y1: 115.528,
    x2: 340.148,
    y2: 102.528,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 341.186,
    y1: 132.644,
    x2: 349.186,
    y2: 121.423,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 314.555,
    y1: 122.172,
    x2: 332.555,
    y2: 134.172,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 314.36,
    y1: 112.236,
    x2: 326.36,
    y2: 102.236,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 284.64,
    y1: 99.2357,
    x2: 302.64,
    y2: 114.236,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 276,
    y1: 106.004,
    x2: 276,
    y2: 129.004,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 280.621,
    y1: 131.078,
    x2: 302.621,
    y2: 122.078,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 307.001,
    y1: 145.956,
    x2: 308.001,
    y2: 124.956,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 313.629,
    y1: 149.075,
    x2: 333.629,
    y2: 141.075,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 285.36,
    y1: 170.236,
    x2: 303.36,
    y2: 155.236,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 278.001,
    y1: 167.04,
    x2: 277.001,
    y2: 139.04,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 272.445,
    y1: 170.836,
    x2: 260.445,
    y2: 162.836,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 272.682,
    y1: 137.735,
    x2: 257.682,
    y2: 151.735,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 246.97,
    y1: 127.761,
    x2: 252.97,
    y2: 151.761,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 240.914,
    y1: 128.41,
    x2: 228.914,
    y2: 155.41,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 249,
    y1: 161.004,
    x2: 232,
    y2: 161.004,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 223.215,
    y1: 157.624,
    x2: 208.215,
    y2: 138.624,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 236.305,
    y1: 122.956,
    x2: 211.305,
    y2: 130.956,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 237.215,
    y1: 115.624,
    x2: 222.215,
    y2: 96.6236,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 250.338,
    y1: 116.254,
    x2: 267.338,
    y2: 101.254,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 220.263,
    y1: 88.3282,
    x2: 231.263,
    y2: 76.3282,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 193.518,
    y1: 106.128,
    x2: 213.518,
    y2: 95.1277,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 190.868,
    y1: 112.508,
    x2: 198.868,
    y2: 126.508,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 94.0039,
    r: 12,
    fill: "#009345"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 118.004,
    r: 5,
    fill: "#1F2188"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 137.004,
    r: 7,
    fill: "#652D93"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 117.004,
    r: 9,
    fill: "#C2272D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 308,
    cy: 151.004,
    r: 7,
    fill: "#006835"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 133.004,
    r: 7,
    fill: "#F05A24"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 174.004,
    r: 9,
    fill: "#2E3192"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 158.004,
    r: 8,
    fill: "#C2272E"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 120.004,
    r: 10,
    fill: "#23B574"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 160.004,
    r: 7,
    fill: "#8DC53E"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 133.004,
    r: 10,
    fill: "#F8931F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 93.0039,
    r: 7,
    fill: "#662E91"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 108.004,
    r: 6,
    fill: "#2E3093"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 308,
    cy: 66.0039,
    r: 11,
    stroke: "#0071BD",
    strokeWidth: 6
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 66.0039,
    r: 11,
    stroke: "#0071BD",
    strokeWidth: 6
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 93.0039,
    r: 11,
    stroke: "#0071BD",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaninsoftLogo);
export default __webpack_public_path__ + "static/media/caninsoft-logo.268c1196f25f36831046a9b479108853.svg";
export { ForwardRef as ReactComponent };